/* Effets de la première moitié de l'accueil Whoosh, portés sans framework
   depuis les composants "use client" de la maquette, mêmes valeurs :
   - hero : vidéo de fond (src/template/hero/HeroVideo.tsx) ;
   - avantages : accordéon et couette qui se secoue en changeant de coloris
     (src/template/avantages-image/SectionAvantagesImage.tsx, CouetteSecouee.tsx) ;
   - sac : scène gsap / ScrollTrigger / SplitText (src/template/sac/SectionSac.tsx).
   Le fichier est appelé par plusieurs sections : il ne s'exécute qu'une fois.
   Initialisation une seule fois par élément ; réinitialisation et nettoyage
   dans l'éditeur Shopify (shopify:section:load / unload). */
(function () {
  if (window.WhooshAccueilA) return;
  window.WhooshAccueilA = true;

  function reduit() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  /* ---- Hero : vidéo de fond ------------------------------------------------
     Sur téléphone, version 720p (plus légère) et affiche 720 ; l'affiche
     couvre le chargement. Animations réduites : on reste sur l'affiche. */
  function initHero(boite) {
    var v = boite.querySelector("video");
    if (!v) return null;
    if (reduit()) return null;
    /* La vidéo démarre après le chargement de la page : l'affiche (même cadrage) s'affiche
       tout de suite, le texte et les images du haut ne sont pas ralentis. */
    /* Les 10 premières images de la vidéo sont un fondu depuis le noir : on démarre et on reboucle après (#t),
       et la vidéo ne s'affiche qu'une fois en lecture. Sur réseau lent ou navigateur intégré qui refuse la
       lecture, l'affiche reste : jamais d'écran figé sombre et flou (bug Instagram du 26/10). */
    var DEBUT = 0.45;
    function lancer() {
      if (window.whVideosCoupees) return;
      var telephone = window.matchMedia("(max-width: 767px)").matches;
      v.loop = false;
      v.addEventListener("playing", function () { v.classList.add("is-prete"); });
      v.addEventListener("ended", function () {
        v.currentTime = DEBUT;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
      v.src = (telephone ? boite.getAttribute("data-telephone") : boite.getAttribute("data-ordinateur")) + "#t=" + DEBUT;
      v.muted = true;
      var lecture = v.play();
      if (lecture && lecture.catch) lecture.catch(function () {});
    }
    /* 2 s après le chargement : le premier affichage est terminé, la vidéo ne le
       concurrence plus (l'affiche est sa première image, le passage ne se voit pas). */
    var DELAI_VIDEO = 2000;
    if (document.readyState === "complete") setTimeout(lancer, DELAI_VIDEO);
    else window.addEventListener("load", function () { setTimeout(lancer, DELAI_VIDEO); }, { once: true });
    return null;
  }

  /* ---- Avantages : bouton « Voir 4 autres avantages » ----------------------- */
  function initAccordeon(acc) {
    var bouton = acc.querySelector(".js-benefits-toggle");
    if (!bouton) return null;
    var contenu = acc.querySelector(".image-with-benefits__accordion-content");
    var texte = bouton.querySelector(".btn-text");
    var ouvert = false;
    function clic() {
      ouvert = !ouvert;
      acc.classList.toggle("is-open", ouvert);
      if (contenu) contenu.setAttribute("aria-hidden", ouvert ? "false" : "true");
      bouton.setAttribute("aria-expanded", ouvert ? "true" : "false");
      if (texte) texte.textContent = bouton.getAttribute(ouvert ? "data-fermer" : "data-ouvrir") || "";
    }
    bouton.addEventListener("click", clic);
    return function () {
      bouton.removeEventListener("click", clic);
    };
  }

  /* ---- Avantages : couette qui se secoue -----------------------------------
     La secousse (animation CSS cs-secousse, 3,2 s) ne tourne que quand
     l'illustration est à l'écran (20 %). À 74 % de chaque secousse, la couette
     passe au coloris suivant : rose, bleu ciel, sauge, gris. */
  var COLORIS = ["rose", "bleu", "sauge", "gris"];
  var CYCLE = 3200; // durée d'une secousse (ms), = animation CSS
  var RETOMBEE = 0.74; // moment du changement de couleur dans la secousse

  function initCouette(scene) {
    if (reduit()) return null;
    var couette = scene.querySelector(".cs-couette");
    var actif = Math.max(0, COLORIS.indexOf(scene.getAttribute("data-coloris")));
    var minuteur;
    var ecoute = false;

    function auTour() {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        actif = (actif + 1) % COLORIS.length;
        scene.setAttribute("data-coloris", COLORIS[actif]);
      }, CYCLE * RETOMBEE);
    }

    function visible(oui) {
      if (oui) {
        if (couette && !ecoute) {
          couette.addEventListener("animationiteration", auTour);
          couette.addEventListener("animationstart", auTour);
          ecoute = true;
        }
        scene.classList.add("cs-scene--anime");
      } else {
        scene.classList.remove("cs-scene--anime");
        clearTimeout(minuteur);
        if (couette && ecoute) {
          couette.removeEventListener("animationiteration", auTour);
          couette.removeEventListener("animationstart", auTour);
          ecoute = false;
        }
      }
    }

    var io = new IntersectionObserver(
      function (entrees) {
        visible(entrees[0].isIntersecting);
      },
      { threshold: 0.2 }
    );
    io.observe(scene);
    return function () {
      io.disconnect();
      visible(false);
    };
  }

  /* ---- Sac : la couette sort du sac ----------------------------------------
     Script gruns-section-benefits.js tel que la maquette l'a repris. */
  var DECLENCHEUR_ORDI = 15; // data-desktop-animation-trigger-position
  var MAINTIEN_FINAL = 10; // finalHoldDuration (%)

  function initSac(n) {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined" || typeof SplitText === "undefined") return null;
    var section = n.closest(".gruns-benefits") || n.parentElement;
    gsap.registerPlugin(ScrollTrigger, SplitText);
    var lignes = Array.prototype.slice.call(n.querySelectorAll(".word-line"));
    if (!lignes.length) return null;
    var couette = n.querySelector(".bear");
    var derniere = lignes[lignes.length - 1];
    var hauteur = function () {
      return n.offsetHeight || window.innerHeight;
    };

    if (reduit()) {
      gsap.set(derniere, { color: "var(--whoosh-accent)" });
      if (couette) gsap.set(couette, { y: "-63%" });
      return null;
    }

    var mm = gsap.matchMedia();

    /* Ordinateur : le script Grüns tel quel (section épinglée, lignes
       découpées par SplitText, montée au défilement). */
    mm.add("(min-width: 992px)", function () {
      ScrollTrigger.create({
        trigger: n,
        start: "top top",
        end: function () {
          return "+=" + hauteur() * (1 + MAINTIEN_FINAL / 100);
        },
        pin: true,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        refreshPriority: -1,
      });
      var split = SplitText.create(lignes, {
        type: "lines",
        mask: "lines",
        tag: "span",
        linesClass: "word-line-split",
        aria: "none", /* lignes seulement : le texte reste lisible tel quel (pas d'aria-label sur un <p>, refusé par l'audit d'accessibilité) */
        autoSplit: true,
        onSplit: function (self) {
          gsap.set([].concat(self.masks, self.lines), { display: "block" });
          var tl = gsap.timeline({
            scrollTrigger: {
              trigger: n,
              start: function () {
                return "top " + DECLENCHEUR_ORDI + "%";
              },
              end: function () {
                return "+=" + hauteur();
              },
              scrub: true,
              invalidateOnRefresh: true,
            },
          });
          self.lines.forEach(function (l) {
            tl.fromTo(l, { y: 0, yPercent: 100 }, { y: 0, yPercent: 0, duration: 0.6, ease: "power2.out", overwrite: "auto" });
          });
          tl.addLabel("final-accent");
          if (couette) tl.to(couette, { y: "-63%", duration: 0.45, ease: "power2.out", overwrite: "auto" }, "final-accent");
          tl.to(derniere, { color: "var(--whoosh-accent)", duration: 0.45, ease: "power2.out", overwrite: "auto" }, "final-accent");
          return tl;
        },
      });
      return function () {
        split.revert();
      };
    });

    /* Téléphone et tablette : pas d'épinglage en JavaScript (il saccade sur
       iPhone avec la barre d'adresse). La scène reste collée en haut de l'écran
       en CSS (position: sticky) ; l'animation suit seulement le défilement de
       la section. Chaque phrase monte d'un bloc dans son masque. */
    mm.add("(max-width: 991px)", function () {
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 65%",
          end: "bottom bottom",
          scrub: 0.3,
          invalidateOnRefresh: true,
        },
      });
      lignes.forEach(function (l) {
        tl.fromTo(l, { yPercent: 100 }, { yPercent: 0, duration: 0.6, ease: "power2.out", force3D: true });
      });
      tl.addLabel("final-accent");
      if (couette) tl.to(couette, { yPercent: -63, duration: 0.45, ease: "power2.out", force3D: true }, "final-accent");
      tl.to(derniere, { color: "var(--whoosh-accent)", duration: 0.45, ease: "power2.out" }, "final-accent");
      tl.to({}, { duration: 0.35 }); // la scène finale reste un instant
    });

    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () {
      ScrollTrigger.refresh();
    });
    return function () {
      mm.revert();
    };
  }

  /* ---- Branchement -------------------------------------------------------- */
  var REGLES = [
    [".hx-hero__picture[data-ordinateur]", initHero],
    [".nuoro-iwb .js-benefits-accordion", initAccordeon],
    [".nuoro-iwb .cs-scene", initCouette],
    [".gruns-benefits .benefits-scroll-wrapper", initSac],
  ];

  function init(racine) {
    REGLES.forEach(function (r) {
      Array.prototype.forEach.call(racine.querySelectorAll(r[0]), function (el) {
        if (el.__whAccueilA) return;
        el.__whAccueilA = r[1](el) || function () {};
      });
    });
  }

  function nettoyer(racine) {
    REGLES.forEach(function (r) {
      Array.prototype.forEach.call(racine.querySelectorAll(r[0]), function (el) {
        if (!el.__whAccueilA) return;
        el.__whAccueilA();
        el.__whAccueilA = null;
      });
    });
  }

  /* gsap / ScrollTrigger / SplitText arrivent après la lecture de la page (window.whLibs, layout/theme.liquid). */
  function demarrer() {
    (window.whLibs || Promise.resolve()).then(function () { init(document); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    nettoyer(e.target);
  });
})();
